import { z } from 'zod';

export const createExpenseSchema = z.object({
  amount: z.number().positive(),
  category: z.string().min(1).max(40),
  date: z.string().datetime(),
  vendor: z.string().max(200).nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
  receiptDocumentId: z.string().nullable().optional(),
  extractedData: z.unknown().nullable().optional(),
  clientId: z.string().nullable().optional(),
});

export const updateExpenseSchema = createExpenseSchema.partial();

export const revenueSummaryQuerySchema = z.object({
  period: z.enum(['month', 'quarter', 'year']).default('month'),
  date: z.string().regex(/^\d{4}-\d{2}(-\d{2})?$/).optional(),
});

export const exportQuerySchema = z.object({
  form: z.enum(['s1a', 's2', 'misa']).default('s1a'),
  period: z.enum(['month', 'quarter', 'year']).default('month'),
  date: z.string().regex(/^\d{4}-\d{2}(-\d{2})?$/).optional(),
});

export const parseReceiptSchema = z.object({
  documentId: z.string().min(1),
});

export type CreateExpenseInput = z.infer<typeof createExpenseSchema>;
export type UpdateExpenseInput = z.infer<typeof updateExpenseSchema>;
export type RevenueSummaryQuery = z.infer<typeof revenueSummaryQuerySchema>;
export type ExportQuery = z.infer<typeof exportQuerySchema>;
export type ParseReceiptInput = z.infer<typeof parseReceiptSchema>;
